<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <parcel-filter filter-name="report" />
      <report-detail-header />
      <report-detail-table v-if="!isLoading" />
    </div>
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { cloneDeep } from 'lodash'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'ReportDetail',
  mixins: [Helpers],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('report', ['loadedReport']),
    ...mapState('parcelFilter', ['currentReportFilter'])
  },
  watch: {
    currentReportFilter: {
      handler: function () {
        this.isLoading = true
        // Everytime we change the parcel filter we set it to the loaded Report and execute the report again
        var report = cloneDeep(this.loadedReport)
        report.Report_Filter = cloneDeep(this.currentReportFilter)
        this.setLoadedReport(report)
        this.executeReport(this.loadedReport).then(() => {
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      },
      deep: true
    }
  },
  created () {
    this.isLoading = true
    this.loadReport(this.$route.params.id).then(() => {
      // on startup load the report then set the parcelFilter from the loaded Report this executes it directly
      this.setParcelFilter({ parcelFilter: this.loadedReport.Report_Filter, filterName: 'report' })
    }).catch(() => {
      this.isLoading = false
    })
  },
  methods: {
    ...mapActions('report', ['loadReport', 'executeReport']),
    ...mapMutations('parcelFilter', ['setParcelFilter']),
    ...mapMutations('report', ['setLoadedReport']),
    // *********************** SEARCH *************************
    search_Clicked (searchValue) {
      // this.$router.push('/parcel-list?search=' + encodeURIComponent(searchValue) );
    }
  }
}
</script>

<style>

</style>
